const o = {
  ArrowDownSolidIcon: () => import("@toruslabs/vue-icons/arrows/ArrowDownSolidIcon"),
  ArrowUpSolidIcon: () => import("@toruslabs/vue-icons/arrows/ArrowUpSolidIcon"),
  ArrowLeftIcon: () => import("@toruslabs/vue-icons/arrows/ArrowLeftIcon"),
  ChevronDownSolidIcon: () => import("@toruslabs/vue-icons/arrows/ChevronDownSolidIcon"),
  ClipboardCopyIcon: () => import("./clipboardCopy-C-55ViHa.js"),
  ClipboardCopyDarkIcon: () => import("./clipboardCopyDark-BvnbKKqF.js"),
  DocumentDuplicateIcon: () => import("@toruslabs/vue-icons/file/DocumentDuplicateIcon"),
  EyeIcon: () => import("@toruslabs/vue-icons/security/EyeIcon"),
  EyeOffIcon: () => import("@toruslabs/vue-icons/security/EyeOffIcon"),
  NftIcon: () => import("./nft-DUKu4cSn.js"),
  PlusIcon: () => import("@toruslabs/vue-icons/notifications/PlusIcon"),
  PlusCircleIcon: () => import("@toruslabs/vue-icons/notifications/PlusCircleIcon"),
  QrcodeIcon: () => import("@toruslabs/vue-icons/software/QrcodeIcon"),
  SwitchHorizontalIcon: () => import("@toruslabs/vue-icons/arrows/SwitchHorizontalIcon"),
  TokenIcon: () => import("./token-C9QIaV9f.js"),
  WalletIcon: () => import("./wallet-5pBcH50n.js"),
  WalletTransparentIcon: () => import("./walletTransparent-ofc_iH_7.js"),
  UserCircleIcon: () => import("@toruslabs/vue-icons/users/UserCircleIcon"),
  LockClosedIcon: () => import("@toruslabs/vue-icons/security/LockClosedIcon"),
  SunIcon: () => import("@toruslabs/vue-icons/others/SunIcon"),
  BellIcon: () => import("@toruslabs/vue-icons/chatting/BellIcon"),
  UserGroupIcon: () => import("@toruslabs/vue-icons/users/UserGroupIcon"),
  AdjustmentsIcon: () => import("@toruslabs/vue-icons/others/AdjustmentsIcon"),
  ExternalLinkIcon: () => import("@toruslabs/vue-icons/mail/ExternalLinkIcon"),
  DownloadIcon: () => import("@toruslabs/vue-icons/software/DownloadIcon"),
  GoogleIcon: () => import("@toruslabs/vue-icons/auth/GoogleIcon"),
  PencilIcon: () => import("@toruslabs/vue-icons/mail/PencilIcon"),
  WifiIcon: () => import("@toruslabs/vue-icons/connection/WifiIcon"),
  CreditCardIcon: () => import("@toruslabs/vue-icons/bank/CreditCardIcon"),
  CurrencyDollarIcon: () => import("@toruslabs/vue-icons/bank/CurrencyDollarIcon"),
  TranslateDarkIcon: () => import("./translateDark-BAHM2249.js"),
  TranslateLightIcon: () => import("./translateLight-DCrbeOhd.js"),
  KeyIcon: () => import("@toruslabs/vue-icons/security/KeyIcon"),
  MenuAltOneIcon: () => import("@toruslabs/vue-icons/menu/MenuAltOneIcon"),
  TrashIcon: () => import("@toruslabs/vue-icons/others/TrashIcon"),
  MoonSolidIcon: () => import("@toruslabs/vue-icons/maps/MoonSolidIcon"),
  DesktopIcon: () => import("@toruslabs/vue-icons/gadgets/DesktopIcon"),
  CalendarIcon: () => import("@toruslabs/vue-icons/others/CalendarIcon"),
  MailIcon: () => import("@toruslabs/vue-icons/mail/MailIcon"),
  CheckCircleIcon: () => import("@toruslabs/vue-icons/notifications/CheckCircleIcon"),
  XCircleIcon: () => import("@toruslabs/vue-icons/notifications/XCircleIcon"),
  XSolidIcon: () => import("@toruslabs/vue-icons/notifications/XSolidIcon"),
  FastIcon: () => import("./Fast-CEUxtuJ5.js"),
  MediumIcon: () => import("./Medium-CG40GHLI.js"),
  SlowIcon: () => import("./Slow-Bj_nR63v.js"),
  QrDarkIcon: () => import("./qrDark-BUfyZGFY.js"),
  WalletConnectIcon: () => import("./signing-MSTji7JZ.js"),
  ArrowRightSolidIcon: () => import("@toruslabs/vue-icons/arrows/ArrowRightSolidIcon"),
  WalletConnectScanIcon: () => import("./walletConnect-DmwCI65r.js"),
  FastDarkIcon: () => import("./FastDark-aAjtOv9d.js"),
  SlowDarkIcon: () => import("./SlowDark-k2hpkJ8o.js"),
  MediumDarkIcon: () => import("./MediumDark-D6e3bsRb.js"),
  LinkIcon: () => import("@toruslabs/vue-icons/mail/LinkIcon"),
  ScannerIcon: () => import("./Scanner-DPLiQQRl.js"),
  ChartSquareBarIcon: () => import("@toruslabs/vue-icons/charts/ChartSquareBarIcon")
};
export {
  o as default
};
